import { LogOut, XCircle } from 'lucide-react';

interface AccessDeniedPanelProps {
  /** Body copy shown under the "Access Denied" heading. Varies per page. */
  message: string;
  /** Invoked when the user clicks the Logout button. */
  onLogout: () => void;
}

/** Full-height centered "Access Denied" card with a Logout button.
 *
 * Extracted verbatim from the `if (!userId)` early returns in
 * AttendanceRegularizationPage and MyApprovalsPage, where this exact markup was
 * duplicated. Only the body `message` differed between the two, so it is a prop;
 * the Logout action is supplied via `onLogout`. */
export function AccessDeniedPanel({ message, onLogout }: AccessDeniedPanelProps) {
  return (
    <div className="min-h-[calc(100vh-140px)] flex items-center justify-center bg-gray-50">
      <div className="text-center p-8 bg-white rounded-xl border border-gray-100 max-w-md">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Access Denied</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={onLogout}
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
        >
          <LogOut className="w-5 h-5" />
          Logout
        </button>
      </div>
    </div>
  );
}
